import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-react-documenteditor/styles/material.css';

import { registerLicense } from '@syncfusion/ej2-base';
import React, { useEffect, useRef, useState } from 'react';
import { DocumentEditorContainerComponent, Toolbar } from '@syncfusion/ej2-react-documenteditor';
import './ResumeEditor.css';

DocumentEditorContainerComponent.Inject(Toolbar);

registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXpfc3RRRmVcWEJ1W0pWYUA=');

const ResumeEditor = ({ file, grammarIssues = [] }) => {
  const containerRef = useRef(null);
  const [fileBuffer, setFileBuffer] = useState(null);
  const serviceUrl = "https://services.syncfusion.com/react/production/api/documenteditor/";

  // Step 1: Convert uploaded file to buffer
  useEffect(() => {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => setFileBuffer(e.target.result);
    reader.onerror = (e) => console.error('File reading error:', e);
    reader.readAsArrayBuffer(file);
  }, [file]);

  // Step 2: Load buffer into the document editor
  useEffect(() => {
    if (!fileBuffer || !containerRef.current) return;

    const arrayBufferToBase64 = (buffer) => {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    };

    const openDocument = () => {
      const container = containerRef.current;
      const editor = container?.documentEditor;
      if (!editor) return setTimeout(openDocument, 100);

      try {
        const base64 = arrayBufferToBase64(fileBuffer);
        editor.open(base64, 'Docx');
        editor.documentName = file.name || 'Resume';
        console.log('✅ File opened successfully');

        // Wait for content to fully load before highlighting
        setTimeout(() => {
          const cleanedIssues = grammarIssues.filter(
            item => typeof item?.incorrect === 'string' && item.incorrect.trim() !== ''
          );
         }, 1000);
      } catch (err) {
        console.error('❌ Failed to open DOCX:', err);
      }
    };

    setTimeout(openDocument, 300);
  }, [fileBuffer, grammarIssues]);

  
  const handleDownload = () => {
    const editorContainer = containerRef.current?.documentEditor;
    if (!editorContainer) return;
 
   
    editorContainer.saveAsBlob('Docx')
      .then((blob) => {
        const fileName = editorContainer.documentName?.replace(/\.[^/.]+$/, '') || 'EditedResume';
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${fileName}.docx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error('❌ Error saving document:', err);
      });
  };
 

  return (
    <div className="control-pane">
      <div className="control-section">
        <div id="documenteditor_container_body">
          <DocumentEditorContainerComponent
            id="container"
            ref={containerRef}
            style={{ display: "block", margin: "70px 0" }}
            height="1200px"
            serviceUrl={serviceUrl}
            enableToolbar={true}
            locale="en-US"
          />
        </div>
        <button onClick={handleDownload} className="download-btn ai-button">
          Download Resume (.docx)
        </button>
      </div>
    </div>
  );
};

export default ResumeEditor;

